/**
 * 보관함(장바구니) 베타 기능 토글 — 계정별(서버 DB) 저장.
 *
 * 진실의 원천은 DAYSIDE_BOOK_MEMBER.CART_BETA_YN. 로그인하면 myInfo 응답의
 * cartBetaYn 으로 hydrate 되고(applyCartBetaValue), 토글은 서버에 저장한다
 * (setCartEnabled → POST /member/updateCartBeta). 한 번 켜면 모든 기기에 적용.
 *
 * localStorage 를 쓰지 않으므로, 새로고침 직후엔 known=false(아직 조회 전) 상태다.
 * 컴포넌트는 known 을 보고 로딩 전엔 보관함 메뉴를 감춰 깜빡임을 피한다.
 */
import baseApi from "../api/baseApi";
import { SUCCESS } from "../constants/commonConstant";

const EVENT = "dbrs:cartBetaChanged";

let enabled = false; // 현재 값 (서버 hydrate 전엔 false)
let known = false; // 서버 값을 한 번이라도 받았는지

export const isCartEnabled = () => enabled;
export const isCartFeatureKnown = () => known;

// 서버(myInfo)에서 받은 cartBetaYn 을 반영. myInfo 를 조회하는 컴포넌트가 호출.
export const applyCartBetaValue = cartBetaYn => {
  enabled = cartBetaYn === "Y";
  known = true;
  window.dispatchEvent(new Event(EVENT));
};

// 토글 저장 — 서버 업데이트 성공 시에만 반영. 성공/실패 promise 반환.
export const setCartEnabled = on => {
  return baseApi
    .post("/member/updateCartBeta", { cartBetaYn: on ? "Y" : "N" })
    .then(res => {
      const result = res && res.data && res.data.result;
      if (!result || result.retCode !== SUCCESS) {
        throw new Error((result && result.retMsg) || "설정 변경에 실패했습니다.");
      }
      enabled = on;
      known = true;
      window.dispatchEvent(new Event(EVENT));
      return true;
    });
};

// 변경 구독. 같은 탭의 커스텀 이벤트로 메뉴/신청화면이 즉시 반영된다.
export const subscribeCartFeature = cb => {
  const onChange = () => cb(isCartEnabled());
  window.addEventListener(EVENT, onChange);
  return () => window.removeEventListener(EVENT, onChange);
};
